import cookies from "../../constants/cookies";
import events from "../../constants/events";

import { resizeSelectShop } from "../../utilities/resizeSelectShop";

import { Base } from "./Base";

import Cookies from "js-cookie";

const selectors = {
  selectShopOption: ".select-shop__option",
};

export class SelectShop extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    resizeSelectShop();
    this.bindFunctions();
    this.setEventListeners();
    this.cacheElements();
    this.checkCookie();
    window.addEventListener(events.LOCATION_SET, this.setActiveCountry);
  }

  checkCookie() {
    const selectedLocation = Cookies.get(cookies.SELECTED_LOCATION);

    if (selectedLocation) {
      this.setActiveCountry();
    }
  }

  bindFunctions() {
    this.handleChange = this.handleChange.bind(this);
  }

  setEventListeners() {
    this.refs.selecter.addEventListener("change", this.handleChange);
  }

  cacheElements() {
    this.selectShopOptions = this.refs.selecter.querySelectorAll(
      selectors.selectShopOption
    );
  }

  handleChange(e) {
    //Not really neccesary since the website redirects on change
    resizeSelectShop();
    const location = `${e.target.value}${
      window.mosmosh.productSKU
        ? `&sku=${window.mosmosh.productSKU}&view=re`
        : ""
    }`;
    window.location.hash = sessionStorage.getItem("dpp-hash");
    window.location.href = location;
  }

  setActiveCountry = () => {
    let country;
    const selectedLocation = Cookies.get(cookies.SELECTED_LOCATION);

    if (selectedLocation) {
      country = selectedLocation;
    }

    if (!selectedLocation) {
      country =
        window.mosmosh.location && window.mosmosh.location.country_code
          ? window.mosmosh.location.country_code
          : "INT";
    }

    this.selectShopOptions.forEach(
      (option) =>
        (option.selected = option.dataset.country === country ? true : false)
    );
  };
}
